const GetJobs = `query getJobs($count: Int, $cursor: String, $filterConfig: JobFilterConfigInput) {
    jobs(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          status
          creationTimestamp
          deliveryTimestamp
          retriable
          retries {
            id
            status
          }    
          integration {
            name
          }
          sender {
            id
            name
            description
          }
          receiver {
            id
            name
            description            
          }
          dataType {
            id
            name
            description
          }
          parents {
            id
          }
        }
      }
    }
  }
 `

const GetPendingBatchJobs = `
  query {
    pendingBatchJobs {
      job {
        id
        creationTimestamp
        sender {
          id
          name
        }
        receiver {
          id
          name
        }
        dataType {
          id
          name
        }
      }
      nextActionTime
    }
  }
`


 const GetJobPayloadPresignedURL = `
  query Query($id: String!, $index: Int) {
    job(id: $id) {
      presignedPayloadUrl(index: $index)
    }
  }
 `

 const GetJob = 
  `query Query($id: String!, $logCount: Int, $logCursor: String, $asc: Boolean) {
    job(id: $id) {
      id
      status
      creationTimestamp
      deliveryTimestamp
      cancellationTimestamp
      failureTimestamp
      fileSize
      scheduledDelivery
      nextActionTime
      retriable

      payloadHistory {
        component
        payloadUrl
      }

      sftpGatewayLog {
        id
      }

      parents {
        id
        status
        creationTimestamp
        integration {
          name
        }
        sender {
          name
        }
        receiver {
          name
        }
        dataType {
          name
        }
      }
      children {
        id
        status
        creationTimestamp
        integration {
          name
        }
        sender {
          name
        }
        receiver {
          name
        }
        dataType {
          name
        }
      }
      batchedJobs {
        id
        status
        creationTimestamp
        integration {
          name
        }
        sender {
          name
        }
        receiver {
          name
        }
        dataType {
          name
        }
      }
      retriedFrom {
        id
        integration {
          name
        }
        creationTimestamp
      }
      retries {
        id
        status
        creationTimestamp
        integration {
          name
        }
        sender {
          id
          name
          description
        }
        receiver {
          id
          name
          description            
        }
        dataType {
          id
          name
          description
        }
      }
      metadata
      logs(first: $logCount, after: $logCursor, asc: $asc) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            businessLog {
              type
              message
              timestamp
            }
            component
            timestamp
            region
            failed
          }
        }
      }  
      dataSource {
        id
        name
        description
      }
      integration {
        id
        name
        description
      }
      sender {
        id
        name
        description
      }
      receiver {
        id
        name
        description
      }
      dataType {
        id
        name
        description
      }
      stagedPayloadUrl
    }
  }
  `

const RetryJob = `
  mutation($id: String!, $forceRetry: Boolean) {
    retryJob(input: {
      jobId: $id,
      forceRetry: $forceRetry
    }) {
      jobId
      errorMessage
    }
  }
  `

const FailJob = `
  mutation($id: String!) {
    failJob(input:{
      jobId: $id
    }) {
      jobId
      errorMessage
    }
  }
`

module.exports = {
  GetJobs,
  GetJob,
  RetryJob,
  FailJob,
  GetJobPayloadPresignedURL,
  GetPendingBatchJobs,
}